import { Timestamp } from '@angular/fire/firestore';
// import { OutputData } from '@editorjs/editorjs';
import { createAction, props } from '@ngrx/store';
import { AppExceptionModel } from '../../models/app-exception.model';
import { Assignment } from '../../models/assignment.school.model';
import { SubmittedAssignment } from '../../models/submit.assignment.school.model';

export const getAssignments = createAction(
  '[School Assignment] Get Assignments',
  props<{
    groupId: string;
    gradeId?: string;
    academicYear: number;
    createdById?: string;
    fromDate?: Timestamp;
    toDate?: Timestamp;
    lastRecord?: Timestamp;
  }>(),
);

export const addAssignmentsToStore = createAction(
  '[School Assignment] Add Assignments to store',
  props<{ assignments: Assignment[] }>(),
);
export const addAssignmentToStore = createAction(
  '[School Assignment] Add Assignment to store',
  props<{ assignment: Assignment }>(),
);

export const getAssignmentsFailure = createAction(
  '[School Assignment] Get Assignments Failed',
  props<{ error: AppExceptionModel }>(),
);

export const getAssignment = createAction(
  '[School Assignment] Get assignment',
  props<{ groupId: string; assignmentId: string }>(),
);

export const getAssignmentFailure = createAction(
  '[School Assignment] Get assignment failure',
  props<{ error: AppExceptionModel }>(),
);

// Create Assignment Actions
export const create = createAction(
  '[School Assignment] Create',
  props<{ groupId: string; assignmentId: string; assignment: Assignment }>(),
);
export const createFailure = createAction(
  '[School Assignment] Create Failure',
  props<{ error: AppExceptionModel }>(),
);
export const createSuccess = createAction(
  '[School Assignment] Create Success',
  props<{ assignment: Assignment }>(),
);

// Update Assignment Actions
export const update = createAction(
  '[School Assignment] Update',
  props<{ groupId: string; assignmentId: string; assignment: Assignment }>(),
);
export const updateFailure = createAction(
  '[School Assignment] Update Failure',
  props<{ error: AppExceptionModel }>(),
);
export const updateSuccess = createAction(
  '[School Assignment] Update Success',
  props<{ assignment: Assignment }>(),
);

export const updateNotesFailure = createAction(
  '[School Assignment] Update Notes Failure',
  props<{ error: AppExceptionModel }>(),
);
export const updateNotesSuccess = createAction(
  '[School Assignment] Update Notes Success',
  props<{ assignment: Assignment }>(),
);

// Submit Assignment Work
export const submitStudentWork = createAction(
  '[School Assignment] Submit Student Work',
  props<{ data: SubmittedAssignment }>(),
);
export const submitStudentWorkFailure = createAction(
  '[School Assignment] Submit Student Work Failure',
  props<{ error: AppExceptionModel }>(),
);
export const submitStudentWorkSuccess = createAction(
  '[School Assignment] Submit Student Work Success',
);

// Delete Assignment Actions
export const deleteAction = createAction(
  '[School Assignment] Delete',
  props<{ groupId: string; assignmentId: string }>(),
);
export const deleteFailure = createAction(
  '[School Assignment] Delete failure',
  props<{ error: AppExceptionModel }>(),
);
export const deleteSuccess = createAction(
  '[School Assignment] Delete success',
  props<{ id: string }>(),
);

export const deleteFromStore = createAction(
  '[School Assignment] Clear from store',
  props<{ id: string }>(),
);

export const loadAssignmentStats = createAction(
  '[School Grade] Load Assignments Stats',
  props<{ groupId: string }>(),
);

export const clear = createAction('[School Assignment] Clear Assignments');

export const clearFromStore = createAction(
  '[School Assignment] Clear multiple from store',
  props<{ ids: string[] }>(),
);

export const clearByAcademicYear = createAction(
  '[School Assignment] Clear Assignments By Academic Year',
  props<{ groupId: string; academicYear: number }>(),
);
